import { receivedSubmission } from "@circle-react/components/SettingsApp/Workflows/components/Events/Forms/receivedSubmission";
import {
  communityMemberAddedToAccessGroup,
  communityMemberRemovedFromAccessGroup,
} from "./AccessGroup";
import { receiveDM } from "./Admin/receiveDM";
import { joinedCommunity } from "./Community";
import { emailChanged } from "./CommunityMember";
import { communityMemberProfileFieldUpdated } from "./CommunityMemberProfileField";
import {
  completedCourse,
  completedLesson,
  completedSection,
  failedQuiz,
  passedQuiz,
  submittedQuiz,
} from "./Course";
import {
  eventEndedForMember,
  eventStartsInAnHour,
  memberAttendedLiveEvent,
  rsvpToEvent,
  rsvpToRecurringEvent,
} from "./Event";
import { leveledDown } from "./Gamification/leveledDown";
import { leveledUp } from "./Gamification/leveledUp";
import { memberTagged, memberUntagged } from "./MemberTag";
import {
  endedPaywallTrialWithoutSubscription,
  memberInstallmentCompletedPaywall,
  memberPurchasedPaywall,
  memberSubscribedPaywall,
  memberSubscriptionResumedPaywall,
  memberSubscriptionScheduledToCancelPaywall,
  memberTrialConvertedPaywall,
  memberTrialEndedAndNotConvertedPaywall,
  memberTrialResumedPaywall,
  memberTrialScheduledToCancelPaywall,
  memberUnsubscribedPaywall,
  memberWorkflowsSubscriptionCanceledPaywall,
  startedPaywallTrial,
} from "./Paywall";
import {
  commentApproved,
  commentCreatedOnPost,
  commentFlagged,
  commentRejected,
  postApproved,
  postFlagged,
  postLiked,
  postPublished,
  postRejected,
} from "./PostBasic";
import {
  eventPublishedInSpace,
  memberJoinedSpace,
  memberLeftSpace,
} from "./Space";
import { memberJoinedSpaceGroup, memberLeftSpaceGroup } from "./SpaceGroup";
import type { EventOption } from "./types";

export const availableEvents: ReadonlyArray<EventOption> = [
  joinedCommunity,
  rsvpToEvent,
  rsvpToRecurringEvent,
  communityMemberAddedToAccessGroup,
  communityMemberRemovedFromAccessGroup,
  memberJoinedSpace,
  memberLeftSpace,
  memberJoinedSpaceGroup,
  memberLeftSpaceGroup,
  memberPurchasedPaywall,
  memberTagged,
  memberUntagged,
  eventEndedForMember,
  postPublished,
  commentCreatedOnPost,
  postFlagged,
  commentFlagged,
  postApproved,
  commentApproved,
  postRejected,
  commentRejected,
  postLiked,
  completedCourse,
  completedLesson,
  completedSection,
  memberSubscribedPaywall,
  memberSubscriptionScheduledToCancelPaywall,
  memberTrialScheduledToCancelPaywall,
  memberUnsubscribedPaywall,
  memberWorkflowsSubscriptionCanceledPaywall,
  memberSubscriptionResumedPaywall,
  memberTrialResumedPaywall,
  memberInstallmentCompletedPaywall,
  memberTrialEndedAndNotConvertedPaywall,
  memberTrialConvertedPaywall,
  startedPaywallTrial,
  endedPaywallTrialWithoutSubscription,
  eventStartsInAnHour,
  eventPublishedInSpace,
  memberAttendedLiveEvent,
  communityMemberProfileFieldUpdated,
  emailChanged,
  leveledUp,
  leveledDown,
  receivedSubmission,
  passedQuiz,
  failedQuiz,
  submittedQuiz,
  receiveDM,
];
